/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React from "react";


import {Button, Col} from "react-bootstrap";


type BhpQuizDisplaySwitcherProps = {
    SHOW_ALL_BHP_QUZIZES_STATUS: boolean;
    SHOW_ALL_BHP_QUZIZES_STATUS_HANDLER(status: boolean): void;
};


export const BhpQuizDisplaySwitcherComponent: React.FC<BhpQuizDisplaySwitcherProps> = ({
    SHOW_ALL_BHP_QUZIZES_STATUS, SHOW_ALL_BHP_QUZIZES_STATUS_HANDLER
}): JSX.Element | null => {


    if (SHOW_ALL_BHP_QUZIZES_STATUS) return null;

    return (
        <Col xs={12} className={"terminals-list-display-switcher-component terminals-list-display-switcher"}>
            <Button onClick={() => SHOW_ALL_BHP_QUZIZES_STATUS_HANDLER(!SHOW_ALL_BHP_QUZIZES_STATUS)}>
                <span>{SHOW_ALL_BHP_QUZIZES_STATUS ? `Pokaż aktywne` : `Pokaż wszystkie `}</span>
            </Button>
        </Col>
    );

};


export default BhpQuizDisplaySwitcherComponent;
